import React, { useState } from 'react';
import {
  Menu,
  X,
  ArrowUpRight,
} from 'lucide-react';
import {
  Link,
  useLocation,
} from 'react-router-dom';

import frocortLogo from '../assets/frocort-logo-navbar.svg';


const navItems = [
  {
    label: 'Technology',
    path: '/technology',
  },
  {
    label: 'Research',
    path: '/research',
  },
  {
    label: 'For Device Makers',
    path: '/for-device-makers',
  },
  {
    label: 'Vision',
    path: '/vision',
  },
];


const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const location = useLocation();


  /*
   * Determine which top-level page is currently active.
   */
  const isActive = (path) => {
    return location.pathname === path;
  };


  /*
   * Close the mobile menu after navigation.
   */
  const handleNavigation = () => {
    setMobileOpen(false);
  };


  return (
      <header className="absolute left-0 right-0 top-0 z-50">

        <nav className="mx-auto max-w-[1400px] px-6 sm:px-8">

          <div className="flex h-20 items-center justify-between">

            {/* Logo */}
            <Link
                to="/"
                aria-label="FroCort home"
                onClick={handleNavigation}
                className="flex shrink-0 items-center"
            >
              <img
                  src={frocortLogo}
                  alt="FroCort"
                  className="h-auto w-[150px]"
              />
            </Link>


            {/* Desktop navigation */}
            <div className="hidden items-center gap-8 lg:flex">

              {navItems.map((item) => {
                const active = isActive(item.path);

                return (
                    <Link
                        key={item.path}
                        to={item.path}
                        aria-current={
                          active
                              ? 'page'
                              : undefined
                        }
                        className={`
                                        text-[12px]
                                        transition-colors
                                        duration-300
                                        ${
                            active
                                ? 'text-white'
                                : 'text-neutral-400 hover:text-white'
                        }
                                    `}
                    >
                      {item.label}
                    </Link>
                );
              })}


              {/* Contact */}
              <Link
                  to="/#contact"
                  className="
                                inline-flex
                                items-center
                                gap-2
                                rounded-full
                                border
                                border-white/15
                                px-4
                                py-2
                                text-[12px]
                                text-white
                                transition-all
                                duration-300
                                hover:bg-white/5
                                hover:border-white/25
                            "
              >
                Contact

                <ArrowUpRight
                    size={14}
                />
              </Link>

            </div>


            {/* Mobile menu button */}
            <button
                type="button"
                aria-label={
                  mobileOpen
                      ? 'Close menu'
                      : 'Open menu'
                }
                aria-expanded={mobileOpen}
                onClick={() =>
                    setMobileOpen(
                        (open) => !open
                    )
                }
                className="
                            flex
                            h-10
                            w-10
                            items-center
                            justify-center
                            rounded-full
                            border
                            border-white/10
                            text-neutral-300
                            transition-colors
                            hover:bg-white/5
                            hover:text-white
                            lg:hidden
                        "
            >
              {mobileOpen ? (
                  <X size={18} />
              ) : (
                  <Menu size={18} />
              )}
            </button>

          </div>


          {/* Mobile navigation */}
          {mobileOpen && (
              <div
                  className="
                            border-t
                            border-white/10
                            bg-[#080a0f]/95
                            backdrop-blur-xl
                            lg:hidden
                        "
              >

                <div className="flex flex-col py-5">

                  {navItems.map((item) => {
                    const active =
                        isActive(item.path);

                    return (
                        <Link
                            key={item.path}
                            to={item.path}
                            onClick={
                              handleNavigation
                            }
                            aria-current={
                              active
                                  ? 'page'
                                  : undefined
                            }
                            className={`
                                            px-2
                                            py-4
                                            text-[15px]
                                            transition-colors
                                            duration-300
                                            ${
                                active
                                    ? 'text-white'
                                    : 'text-neutral-300 hover:text-white'
                            }
                                        `}
                        >
                          {item.label}
                        </Link>
                    );
                  })}


                  {/* Mobile Contact */}
                  <Link
                      to="/#contact"
                      onClick={
                        handleNavigation
                      }
                      className="
                                    mt-3
                                    inline-flex
                                    items-center
                                    justify-center
                                    gap-2
                                    rounded-full
                                    bg-white
                                    px-5
                                    py-3
                                    text-[13px]
                                    font-medium
                                    text-neutral-950
                                    transition-colors
                                    hover:bg-neutral-200
                                "
                  >
                    Contact

                    <ArrowUpRight
                        size={15}
                    />
                  </Link>

                </div>

              </div>
          )}

        </nav>

      </header>
  );
};


export default Navbar;